import { render } from "./IdentityPreview.vue?vue&type=template&id=2839269a"
import script from "./IdentityPreview.vue?vue&type=script&lang=js"
export * from "./IdentityPreview.vue?vue&type=script&lang=js"

import "./IdentityPreview.vue?vue&type=style&index=0&id=2839269a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__